import * as React from "react";
import { Route, Switch } from "react-router-dom";
import { BrowserPageTitle } from "../../components/BrowserPageTitle/BrowserPageTitle";
import {
  PATH_ACCOUNT_STAKEHOLDERS,
  PATH_ACCOUNT_STAKEHOLDERS_ADD,
  PATH_ACCOUNT_STAKEHOLDERS_EDIT
} from "./paths";
import { RouteAddStakeholder } from "./routes/RouteAddStakeholder";
import { RouteEditStakeholder } from "./routes/RouteEditStakeholder";
import { RouteStakeholders } from "./routes/RouteStakeholders";

export const AccountStakeholders = () => {
  return (
    <>
      <BrowserPageTitle title="Team" />
      <Switch>
        <Route
          path={PATH_ACCOUNT_STAKEHOLDERS}
          component={RouteStakeholders}
          exact
        />
        <Route
          path={PATH_ACCOUNT_STAKEHOLDERS_ADD}
          component={RouteAddStakeholder}
          exact
        />
        <Route
          path={PATH_ACCOUNT_STAKEHOLDERS_EDIT}
          component={RouteEditStakeholder}
          exact
        />
      </Switch>
    </>
  );
};
